import { Component } from '@angular/core';
@Component({
  selector : 'application-navigation',
  template : 'This is where the navigation menu goes.....\n<nav>\n  <li routerLinkActive="active">\n    <a routerLink="practices">Practices</a>\n  </li>\n  <li routerLinkActive="active">\n    <a routerLink="asdfasdf">404 Test</a>\n  </li>\n</nav>\n'
})
export class NavigationComponent{

}